const { h, render, Component } = require('preact');

class ID extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <tr>
        <td>{I18n.translate("js.modules.support.order_no")}:</td>
        <td>{this.props.orderDetails.id}</td>
      </tr>
    );
  }
}
module.exports = ID
